module.exports = __webpack_public_path__ + "img/Christmas-game.6e930bc1.svg";